import React from "react"
import {Box, TextField, type SxProps, type TextFieldProps, type Theme as MuiTheme} from "@mui/material"
import {floatingInputSx} from "../../styles/inputStyles"
import FieldLabel from "./FieldLabel"

interface LabeledTextFieldProps extends Omit<TextFieldProps, "label"> {
  label: string
  textColor: string
  containerSx?: SxProps<MuiTheme>
}

export default function LabeledTextField({
                                           label,
                                           textColor,
                                           containerSx,
                                           ...rest
                                         }: LabeledTextFieldProps) {
  return (
    <Box sx={[{width: "100%"}, ...(Array.isArray(containerSx) ? containerSx : [containerSx])]}>
      <FieldLabel textColor={textColor}>{label}</FieldLabel>
      <TextField fullWidth sx={floatingInputSx} {...rest}/>
    </Box>
  )
}
